import { FontFamilyOption } from 'globalStyles';
import {
  Item,
  useGetGoogleFontsQuery,
} from 'queries/googleFonts/getGoogleFontsQuery';
import { useEffect, RefObject, useState } from 'react';

export function useOutsideAlerter(ref: RefObject<any>, effect: Function) {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        effect();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

//consider to remove this in the future and use CSS media queries
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

export const useContainerDimensions = (ref: any) => {
  const getDimensions = () => ({
    width: ref.current && ref.current.offsetWidth,
    height: ref.current && ref.current.offsetHeight,
  });

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const handleResize = () => {
      setDimensions(getDimensions());
    };

    if (ref.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [ref]);

  return dimensions;
};

export const useFontFamilyOptions = () => {
  const [allFontFamilyOptions, setAllFontFamilyOptions] = useState<
    FontFamilyOption[]
  >([]);
  const { data: googleFonts } = useGetGoogleFontsQuery();

  useEffect(() => {
    if (googleFonts?.items) {
      const mappedFonts = googleFonts.items.map(
        (font: Item): FontFamilyOption => ({
          value: font.family,
          label: font.family,
          variants: font.variants,
          files: font.files,
        })
      );
      setAllFontFamilyOptions(mappedFonts);
    }
  }, [googleFonts]);

  return allFontFamilyOptions;
};
